import { Directive } from '@angular/core';

@Directive({
  selector: '[ncisXpoChipMedium]',
  host: { class: 'xpo-Chip--medium' },
})
// This directive is to fullfil a specific design requirement
export class XpoChipMediumDirective {}
